<script setup>
import PageContentLayout from 'dashboard/components-next/layout/PageContentLayout.vue';
</script>

<template>
  <div class="w-full overflow-auto bg-n-surface-1 px-6">
    <PageContentLayout class="pb-12">
      <router-view />
    </PageContentLayout>
  </div>
</template>
